import React, { FunctionComponent } from 'react'
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'

import { Image as ExpoImage, ImageProps as ExpoImageProps, ImageStyle } from 'expo-image'
import styled from 'styled-components/native'

const ImageContainer = styled(ExpoImage)({ flex: 1 })

export const Image: FunctionComponent<ExpoImageProps & { ariaLabel?: string; dataSet?: Dict }> = ({
  testID,
  accessibilityIgnoresInvertColors,
  children,
  style,
  alt,
  ariaLabel,
  accessibilityLabel,
  dataSet,
  ...rest
}) => {
  const finalAccessibilityLabel = alt ?? accessibilityLabel
  const isDecorative = !ariaLabel && !finalAccessibilityLabel

  return (
    <View testID={testID} style={style as Partial<ViewStyle>} dataSet={dataSet}>
      <ImageContainer
        accessible={!isDecorative}
        // DO NOT add default aria label, it will cause a11y violoation if the image also has alt / accessibilityLabel defined
        {...(ariaLabel && { 'aria-label': ariaLabel })}
        accessibilityIgnoresInvertColors={accessibilityIgnoresInvertColors}
        {...rest}
        {...(finalAccessibilityLabel && { accessibilityLabel: finalAccessibilityLabel })}
        style={styles(style)}
      >
        {children}
      </ImageContainer>
    </View>
  )
}

const image = StyleSheet.create({
  imageContainer: {
    margin: 0,
    padding: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
})

const styles = (style?: StyleProp<ImageStyle> | undefined) => StyleSheet.flatten([style, image.imageContainer])
